import React from 'react';
import {Grid} from '@material-ui/core'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxInputFirma from '../Inputs/CheckBoxInputFirma'

function index(props) {
    return (
        <>
          <Grid
            container
            direction="row"
            alignItems="center"
            >
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Kontaktperson namn" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Kontaktperson e-post" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Kontaktperson tele" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Kontaktperson personnr" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Kontaktperson roll" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputFirma Meta="Firmatecknare" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
            </Grid>
        </>
    );
}

export default index;